<template>
  <tableau-view v-if="url" :url="url"></tableau-view>
</template>
<script>

import TableauView from '@/components/tb_view';

export default {
  components: {
    TableauView
  },
  data () {
    return {
      hlUrl: '',
      baboUrl: '',
      tiraUrl: 'https://tableau.wuren.com/t/rockey/views/_16369497376010/sheet0_1?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link&:refresh=yes',
      url: '',
    }
  },
  mounted() {

    let system = this.$route.params.system;

    if (system == 'tira') {
      this.url = this.tiraUrl;

    } else if (system == 'babo') {
      this.url = this.baboUrl;

    } else {
      this.url = this.hlUrl;
    }

  }
}
</script>
<style lang='less' scoped>
.container {
  padding: 20px;
}
</style>
